// components/DeparturesList.jsx
import React from 'react';
import DepartureCard from './DepartureCard';

/**
 * Unified departures list component.
 * Used in both StopDetails page and StopBottomSheet (map view).
 */
function DeparturesList({ departures }) {
    if (!departures || departures.length === 0) {
        return (
            <div className="no-departures">
                Brak zaplanowanych odjazdów w najbliższym czasie.
            </div>
        );
    }

    // Sort by estimated time
    const sortedDepartures = [...departures]
        .filter(d => d.estimatedTime)
        .sort((a, b) => a.estimatedTime.localeCompare(b.estimatedTime));

    return (
        <div className="departures-list" role="list" aria-label="Lista odjazdów">
            {sortedDepartures.map((departure, index) => (
                <DepartureCard key={`${departure.routeShortName}-${index}`} departure={departure} />
            ))}
        </div>
    );
}

export default DeparturesList;
